import axios from "utils/axios";
import type { CustomAxiosRequestConfig } from "@xt/xtbase";
import { RcFile } from "antd/lib/upload";
const URL = "/uaapi/user/";

//用户增加访问量
export function post_userAddVisitNum(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/user/addVisitNum`, null, config);
}

//获取企业认证申请ID
export function post_enterpriseApplyGetApplyId(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `private/enterpriseApply/getApplyId`, null, config);
}

// 获取企业认证结果
export function get_enterpriseApplyReason(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `private/enterpriseApply/result`, config);
}

//获取企业认证信息
export function get_enterpriseAuthInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `private/enterpriseAuth/info`, config);
}

// 用户vip信息
export function getVipInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `private/userVip/info`, config);
}

//获取企业基本信息
export function get_enterpriseInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `private/enterprise/info`, config);
}

//编辑企业基本信息
export function post_enterprise(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `private/enterprise`, null, config);
}

//编辑企业基本信息--保存草稿
export function post_enterpriseSaveDraft(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `private/enterprise/saveDraft`, null, config);
}

//获取企业成员列表
export function get_enterpriseMemberList(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `private/enterpriseMember/list`, config);
}
//编辑企业成员信息
export function post_enterpriseMemberBatchSave(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `private/enterpriseMember/batchSave`, null, config);
}

//编辑企业成员信息--保存草稿
export function post_enterpriseMemberBatchSaveDraft(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `private/enterpriseMember/batchSaveDraft`, null, config);
}

//获取企业资质列表
export function get_enterpriseQualificationList(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `private/enterpriseQualification/list`, config);
}
//编辑企业资质--保存草稿
export function post_enterpriseQualificationBatchSaveDraft(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `private/enterpriseQualification/batchSaveDraft`, null, config);
}

//编辑企业资质
export function post_enterpriseQualificationBatchSave(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `private/enterpriseQualification/batchSave`, null, config);
}
//提交审核
export function put_enterpriseApply(id: string, config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `private/enterpriseApply/${id}`, null, config);
}
//上传文件
export function post_upload(file: RcFile, config?: CustomAxiosRequestConfig) {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(URL + `private/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    ...(config || {}),
  });
}

//获取提现限制
export function get_businessIsForbid(config?: CustomAxiosRequestConfig<{ businessCode: string }, { a: string }>) {
  return axios.get(URL + `private/business/isForbid`, config);
}


//用户申请开通业务，提交审核
export function businessApply(config) {
  return axios.post(URL + `private/business/apply`, config);
}

// 用户开通列表
export function businesslist(config) {
  return axios.get(URL + `private/business/list`, config);
}

// 根据业务类型查询最新审核信息
export function businessgetNewestByCode(config) {
  return axios.get(URL + `private/business/getNewestByCode`, config);
}